import { AccountSettingsProvider } from "./AccountSettingsProvider";
import { ApiKeysProvider } from "./ApiKeysProvider";
import { BalancesProvider } from "./BalancesProvider";
import { BanksListProvider } from "./BanksListProvider";
import { DeveloperSettingsProvider } from "./DeveloperSettingsProvider";

export function RemoteDataProviders({
  children,
}: {
  children: React.ReactNode;
}) {
  // TODO: check to ensure all the providers are loaded before displaying the dashboard
  // to achieve this, wrap children with a component that checks isLoading of all the Wrapper contexts
  return (
    <AccountSettingsProvider>
      <ApiKeysProvider>
        <DeveloperSettingsProvider>
          {/* <UserBusinessesProvider> */}
          <BalancesProvider>
            {/* BankList Provider Uses Balances */}
            <BanksListProvider>{children}</BanksListProvider>
          </BalancesProvider>
          {/* </UserBusinessesProvider> */}
        </DeveloperSettingsProvider>
      </ApiKeysProvider>
    </AccountSettingsProvider>
  );
}
